/* Justyol — cart-page in-app launch promo (window.JY_IS_APP).
   Applies the fixed discount to the cart total on load AND after every cart
   mutation. The theme re-renders <main-cart> via innerHTML on quantity/remove
   changes, and scripts injected through innerHTML do NOT re-execute — so this
   lives in an external file and re-applies on the document 'cart:updated'
   event (dispatched by cart.js right after the section swap). Reads its inputs
   from data-* attributes on the freshly-rendered summary, so it always works
   off the current cart, never a stale first-paint snapshot.

   Bigger-wins vs any existing cart discount; the worker enforces the same
   amount authoritatively at order creation, so the shown total matches the
   charge. Display only. */
(function () {
  'use strict';

  function money(cents, isAr) {
    var n = Math.round(cents / 100);
    return n.toLocaleString(isAr ? 'ar-MA' : 'fr-FR') + (isAr ? ' درهم' : ' Dhs');
  }

  function apply() {
    if (window.JY_IS_APP !== true) return;
    var box = document.querySelector('[data-jy-cart-offer]');
    if (!box) return;
    var base = window.JY_COD_ENDPOINT ? String(window.JY_COD_ENDPOINT).replace(/\/+$/, '') : '';
    if (!base) return;

    var isAr = box.getAttribute('data-ar') === '1';
    /* grand = server total WITHOUT promo (incl. shipping fee when not free).
       A cart discount is baked into cart.total_price, so add it back to get the
       goods basis the worker computes from. */
    var grand = parseInt(box.getAttribute('data-grand'), 10) || 0;
    var price = parseInt(box.getAttribute('data-price'), 10) || 0;
    var otherCents = parseInt(box.getAttribute('data-disc'), 10) || 0;
    var grandCents = grand + otherCents;
    var subMad = (price + otherCents) / 100;

    fetch(base + '/app/first-order-offer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ subtotal: subMad }),
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok || !j.active) return;
        var more = document.querySelector('[data-jy-cart-appmore]');
        if (!j.qualifies) {
          if (more && j.remaining) {
            more.hidden = false;
            more.textContent = isAr
              ? '🎁 ضِف ' + Math.ceil(j.remaining) + ' درهم واحصل على خصم ' + j.offer + ' درهم من التطبيق'
              : '🎁 Ajoutez ' + Math.ceil(j.remaining) + ' Dhs et obtenez ' + j.offer + ' Dhs de remise app';
          }
          return;
        }
        /* bigger wins: only show the promo if it beats the existing cart
           discount (otherwise the discounted server total already stands) */
        if (Math.round(j.discount * 100) <= otherCents) return;
        var offCents = Math.min(Math.round(j.discount * 100), grandCents);
        /* the app promo REPLACES the Shopify discount — hide that row so the
           total isn't double-counted */
        var discRow = document.querySelector('[data-jy-cart-discrow]');
        if (discRow) discRow.hidden = true;
        var approw = document.querySelector('[data-jy-cart-approw]');
        var appamt = document.querySelector('[data-jy-cart-app]');
        if (approw) approw.hidden = false;
        if (appamt) appamt.textContent = '−' + money(offCents, isAr);
        var newTotal = money(grandCents - offCents, isAr);
        var totalEl = document.querySelector('[data-jy-cart-total]');
        if (totalEl) totalEl.textContent = newTotal;
        /* update every sticky-bar total (there can be more than one wrap) */
        var bars = document.querySelectorAll('.jy-cart-stickybar__value');
        for (var i = 0; i < bars.length; i++) bars[i].textContent = newTotal;
        /* AOV upsell: already earning a tier, but a bigger one is within reach —
           nudge toward the next threshold instead of hiding the hint */
        if (more) {
          if (j.nextOffer && j.remainingToNext) {
            more.hidden = false;
            more.textContent = isAr
              ? '🎁 ضِف ' + Math.ceil(j.remainingToNext) + ' درهم واحصل على خصم ' + j.nextOffer + ' درهم من التطبيق'
              : '🎁 Ajoutez ' + Math.ceil(j.remainingToNext) + ' Dhs et obtenez ' + j.nextOffer + ' Dhs de remise app';
          } else {
            more.hidden = true;
          }
        }
      })
      .catch(function () { /* silent — degrade to the plain server total */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  /* re-apply after the theme swaps the cart section on every mutation */
  document.addEventListener('cart:updated', apply);
})();
